import { PhotoMode } from "./Config";

export const validateRequiredPhotos = (pictures: any, photoMode: PhotoMode) => {
  return !(photoMode === PhotoMode.REQUIRED && pictures.length === 0);
};
